import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

export interface Group {
    groupType: number;
    order: number;
    title: string;
    shippingCost?: number;
    shippingCostDisplay: string;
    lineSubtotal?: number;
    subGroups?: SubGroups[];
    count: number;
    type: string;
    showEligibleIcon: boolean;
}
export interface SubGroups {
    groupType: number;
    order: number;
    title: string;
    shippingCost?: number;
    shippingCostDisplay: string;
    lineItems?: string[];
    cartLines?: CartLineModel[];
    vendorName?: string;
    vendorId?: string;
    lineSubtotal?: number;
    showEligibleIcon: boolean;
}

export const getFlatGroups = (groups: Group[], cartLines: CartLineModel[]) => {
    const flatGroups = [] as Group[];

    // Convert cartlins to object
    const cartLinesObject: { [key: string]: CartLineModel } = {};
    cartLines?.forEach(line => {
        cartLinesObject[line.id] = line;
    });
    groups.forEach(group => {
        let newGroup = group;
        const { subGroups, ...restGroupData } = newGroup;
        const subGroupsLengths = subGroups?.reduce((acc, subGroup) => {
            acc += subGroup?.lineItems?.length ?? 0;
            return acc;
        }, 0);
        flatGroups.push({
            ...restGroupData,
            count: subGroupsLengths || 0,
            type: "group",
        });
        const count = newGroup.count ?? 0;
        group?.subGroups?.forEach((subGroup, index) => {
            const lineItemsLength = subGroup.lineItems?.length ?? 0;
            newGroup = {
                ...newGroup,
                count: count + lineItemsLength,
            };
            subGroup?.lineItems?.forEach(lineItem => {
                if (newGroup?.subGroups) {
                    const currentCartLines = newGroup?.subGroups[index]?.cartLines ?? [];
                    newGroup.subGroups[index] = {
                        ...subGroup,
                        cartLines: [...currentCartLines, cartLinesObject[lineItem]],
                    };
                }
            });

            if (newGroup?.subGroups) {
                flatGroups.push({
                    ...newGroup.subGroups[index],
                    type: "sub-group",
                    showEligibleIcon: group.groupType === 1,
                } as any);
            }
        });
        return newGroup;
    });
    return flatGroups;
};
